import React, { Children, Suspense } from 'react'
import classNames from 'classnames'
import { Loading } from '@pandiafi/components'

import { HeaderButton, HeaderButtonProps } from './View.Header/HeaderButton'
import ViewHeader, { ViewHeaderProps } from './View.Header'
import ViewSidebar, { ViewSidebarProps } from './View.Sidebar'
import ViewContent, { ViewContentProps } from './View.Content'
import HeaderTitle, { HeaderTitleProps } from './View.Header/HeaderTitle'
import { HeaderLink, HeaderLinkProps } from './View.Header/HeaderLink'

interface ViewProps {
  children: React.ReactNode[]
  allowOverflow?: boolean
}

type ViewType = React.FC<ViewProps> & {
  Header: React.FC<ViewHeaderProps>
  HeaderTitle: React.FC<HeaderTitleProps>
  HeaderLink: React.FC<HeaderLinkProps>
  Sidebar: React.FC<ViewSidebarProps>
  Content: React.FC<ViewContentProps>
  HeaderButton: React.FC<HeaderButtonProps>
}

export const View: ViewType = (props) => {
  const { children, allowOverflow = false } = props

  const elements = Children.toArray(children)

  if (elements.length !== 3) throw Error('<View> only accepts 3 children')

  const header = elements[0]
  const sidebar = elements[1]
  const content = elements[2]

  return (
    <div
      className={classNames(
        'min-h-[95vh] bg-white',
        allowOverflow ? 'overflow-visible' : 'overflow-hidden'
      )}
    >
      {header}
      <div
        className={classNames(
          'px-4 pb-10',
          'tablet:max-w-2xl tablet:mx-auto tablet:px-1.5',
          'desktop:max-w-7xl desktop:mx-auto desktop:px-24 desktop:py-0'
        )}
      >
        <div className="desktop:grid desktop:grid-cols-3 desktop:gap-16">
          <Suspense fallback={<Loading variant="details" />}>
            {sidebar}
          </Suspense>
          <Suspense fallback={<Loading variant="details" />}>
            {content}
          </Suspense>
        </div>
      </div>
    </div>
  )
}

View.Header = ViewHeader
View.HeaderLink = HeaderLink
View.HeaderTitle = HeaderTitle
View.Sidebar = ViewSidebar
View.Content = ViewContent
View.HeaderButton = HeaderButton
